export const DEFAULT_TIMING = 1;
